/* eslint-disable react/prop-types */
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { APIProvider } from "@vis.gl/react-google-maps";
import DocumentsMap from "./DocumentsMap";

function MapDialog({
  open,
  onClose,
  documents,
  markerLocations,
  onMarkerClick,
  mapsLoaded,
  setMapsLoaded,
  t,
  translationPrefix = "myDocuments",
}) {
  return (
    <Dialog
      maxWidth="lg"
      open={open}
      onClose={onClose}
      sx={{ "& .MuiDialog-paper": { width: "800px", borderRadius: 2 } }}
    >
      <DialogTitle>
        {t(`${translationPrefix}.mapTitle`)}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <APIProvider
          apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
          libraries={["places"]}
          onLoad={() => setMapsLoaded(true)}
        >
          <DocumentsMap
            mapsLoaded={mapsLoaded}
            documents={documents}
            markerLocations={markerLocations}
            onClose={onClose}
            onMarkerClick={onMarkerClick}
            t={(key) => t(`${translationPrefix}.${key}`)}
          />
        </APIProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {t(`${translationPrefix}.closeButton`)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MapDialog;
